//中山大学水表
import request from "./http";
import qs from 'qs'

//角色档案
// *角色档案->查询所有角色档案
export function findRoleFile() {
    return request({
        url: "/roleFile/findRoleFile",
        method: "get",
    });
}

// *角色档案->添加-修改角色档案
// remark 备注
// roleName 角色名称
// id 修改需要
export function saveRoleFile(params) {
    return request({
        url: "/roleFile/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}

// *角色档案->根据Id删除角色档案
//  id 角色id
export function deleteRoleFile(params) {
    return request({
        url: "/roleFile/delete",
        method: "delete",
        params
    });
}

// *限量管理->根据角色roleFileId查询限时,限量,透支额度
//  roleFileId 角色roleFileId
export function findByRoleFileId(params) {
    return request({
        url: "/limit/findByRoleFileId",
        method: "get",
        params
    });
}

// *限量管理->限时,限量,透支额度设置
//  dosage 限制用量
//  overdraft 透支额度
//  roleFileId 账户角色类型Id
//  timeNum 限时数
export function saveLimitQuantity(params) {
    return request({
        url: "/limit/saveLimitQuantity",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data:params
    });
}


// *缴费方式->查询全部缴费方式
export function findMethods() {
    return request({
        url: "/payment/findMethods",
        method: "post",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
    });
}

// *缴费方式->新增缴费方式
// paymentName 缴费名称
export function savePayment(params) {
    return request({
        url: "/payment/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data:params
    });
}

// *缴费方式->删除缴费方式
// id 	缴费方式Id
export function deletePayment(params) {
    return request({
        url: "/payment/delete",
        method: "delete",
        params
    });
}

// *表类型->查询全部表类型
export function findMeterType() {
    return request({
        url: "/meterType/findMeterType",
        method: "post",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
    });
}

// *表类型->新增表类型
// paymentName 表类型名称
export function saveMeterType(params) {
    return request({
        url: "/meterType/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data:params
    });
}

// *表类型->删除表类型
// id 	表类型Id
export function deleteMeterType(params) {
    return request({
        url: "/meterType/delete",
        method: "delete",
        params
    });
}

// *IC卡管理->查询全部IC卡
export function findICCards(params) {
    return request({
        url: "/icCard/findICCards",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params

    });
}

// *IC卡管理->新增
// cardNum 卡号
// remarks 备注
export function saveIcCard(params) {
    return request({
        url: "/icCard/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data:params
    });
}

// *IC卡管理->删除
// id 	IC卡Id
export function deleteIcCard(params) {
    return request({
        url: "/icCard/delete",
        method: "delete",
        params
    });
}


// *IC卡管理->根据卡号查询卡的状态
// id 	IC卡Id
export function findByCardNum(params) {
    return request({
        url: "/icCard/findByCardNum",
        method: "get",
        params
    });
}

// *IC卡管理->批量添加(Excel导入)
export function icCardSaveExcel(params) {
    return request({
        url: "/icCard/saveExcel",
        method: "post",
        headers:{
            'Content-Type':'multipart/form-data',
            'Accept':'*/*'
          },
          data:params

    });
}


// *IC卡管理->导出(Excel导出)
export function icCardFindExcel(params) {
    return request({
        url: "/icCard/findExcel",
        method: "get",
        params

    });
}


// *业主用户管理->根据筛选条件查询账户信息
export function findFilterUser(params) {
    return request({
        url: "/owner/findFilterUser",
        method: "get",
        params
    });
}

// *业主用户管理->根据档案Id查询用户档案
// userProfilesId
export function findByUserProfilesId(params) {
    return request({
        url: "/owner/findByUserProfilesId",
        method: "get",
        params
    });
}

// *业主用户管理->添加修改
// 
export function saveOwner(params) {
    return request({
        url: "/owner/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data:params
    });
}
// *业主用户管理->根据id删除账号
// id 	IC卡Id
export function deleteOwner(params) {
    return request({
        url: "/owner/delete",
        method: "delete",
        params
    });
}


// *业主用户管理->批量添加(Excel导入)
export function ownerSaveExcel(params) {
    return request({
        url: "/owner/saveExcel",
        method: "post",
        headers:{
            'Content-Type':'multipart/form-data',
            'Accept':'*/*'
          },
          data:params

    });
}

// *操作记录->业主操作记录查询
export function findOperatingRecord(params) {
    return request({
        url: "/owner/findOperatingRecord",
        method: "get",
        params
    });
}


// *操作记录->操作类型查询
export function findRecordType() {
    return request({
        url: "/owner/findRecordType",
        method: "get",
    });
}




// 水表管理
// *水表设备查询->水表设备状态记录
export function getWaterCurrentState(params) {
    return request({
        url: "/waterCurrentState/getWaterCurrentState.do",
        method: "get",
        params
    });
}

// *设备查询->设备用量记录
export function getMeterConsumption(params) {
    return request({
        url: "/meterConsumptionRecord/getMeterConsumption.do",
        method: "get",
        params
    });
}


// *设备查询->设备操作记录
export function getWaterOperationRecord(params) {
    return request({
        url: "/waterOperationRecord/getWaterOperationRecord.do",
        method: "get",
        params
    });
}